import { createAsyncThunk } from '@reduxjs/toolkit';
import type {
  CategoryPage,
  CustomPage,
  StoryPage,
  TagPage,
} from '@vgtv/api-client/lib/page';
import type { SvpCategory } from '@vgtv/api-client/lib/svp_category';
import type { CnpTag } from '@vgtv/api-client/lib/cnp_tag';
import type { CnpStory } from '@vgtv/api-client/lib/cnp_story';

import { config } from '../../config';
import { fetchHelper } from '../../helpers/fetch';
import type { Vendor } from '../../types';
import { getAppCapabilitiesHeader } from '../../shared/appCapabilities';

const { apiHostname } = config;

const fetchPageByCategoryId = createAsyncThunk(
  'pages/fetchByCategoryId',
  async ({
    categoryId,
    vendor,
  }: {
    categoryId: SvpCategory['id'];
    vendor: Vendor;
  }): Promise<CategoryPage> => {
    const fetchUrl = `${apiHostname}${vendor}/pages/categories/${categoryId}`;

    return fetchHelper<CategoryPage>(fetchUrl, {
      headers: getAppCapabilitiesHeader(),
    });
  }
);

const fetchPageByTagId = createAsyncThunk(
  'pages/fetchByTagId',
  async ({
    tagId,
    vendor,
  }: {
    tagId: CnpTag['id'];
    vendor: Vendor;
  }): Promise<TagPage> => {
    const fetchUrl = `${apiHostname}${vendor}/pages/tags/${tagId}`;

    return fetchHelper<TagPage>(fetchUrl, {
      headers: getAppCapabilitiesHeader(),
    });
  }
);

const fetchPageByStoryId = createAsyncThunk(
  'pages/fetchByStoryId',
  async ({
    storyId,
    vendor,
  }: {
    storyId: CnpStory['id'];
    vendor: Vendor;
  }): Promise<StoryPage> => {
    const fetchUrl = `${apiHostname}${vendor}/pages/stories/${storyId}`;

    return fetchHelper<StoryPage>(fetchUrl, {
      headers: getAppCapabilitiesHeader(),
    });
  }
);

const fetchPageBySlug = createAsyncThunk(
  'pages/fetchBySlug',
  async ({
    slug,
    vendor,
  }: {
    slug: string;
    vendor: Vendor;
  }): Promise<CustomPage> => {
    const fetchUrl = `${apiHostname}${vendor}/pages/custom/${slug}`;

    return fetchHelper<CustomPage>(fetchUrl, {
      headers: getAppCapabilitiesHeader(),
    });
  }
);

export {
  fetchPageByCategoryId,
  fetchPageByTagId,
  fetchPageByStoryId,
  fetchPageBySlug,
};
